export const PERIOD_ACCESS_TYPES = {
    ONE_TIME: 'One Time',
    PERMANENT: 'Ongoing',
};

export const INDUSTRY_TYPE = {
    Automotive: 'AUTOMOTIVE',
    Trucking: 'TRUCKING',
    Residental: 'RESIDENTAL',
};

export const INDUSTRY_TYPE_DROPDOWN_OPTION = {
    [INDUSTRY_TYPE.Automotive]: {
        id: INDUSTRY_TYPE.Automotive,
        label: 'Automotive',
    },
    [INDUSTRY_TYPE.Trucking]: {
        id: INDUSTRY_TYPE.Trucking,
        label: 'Trucking',
    },
    [INDUSTRY_TYPE.Residental]: {
        id: INDUSTRY_TYPE.Residental,
        label: 'Residental',
    },
};

export const GATE_IN = 'IN';
export const GATE_OUT = 'OUT';
export const QUICK_FILL_EXCLUDED_FIELDS = ['cargo.fourKitesStarted', 'cargo.ocrVerified'];

// How long a discarded transaction's locally-cached form snapshot remains
// valid for rehydration on reopen (8h). Sourced here so the reopen SLA is
// business-configurable rather than buried as a magic number.
export const DISCARDED_FORM_TTL_MS = 8 * 60 * 60 * 1000;

export const VEHICLE_PROPERTIES = ['vehicle.unitNumber', 'vehicle.licensePlateNumber'];
export const TRAILER_PROPERTIES = [
    'trailer.trailerNumber',
    'trailer.trailerNumberTwo',
    'trailer.containerNumber',
    'trailer.chassisNumber',
    'trailer.dollyNumber',
    'trailer.equipmentNumber',
];

export const EQUIP_AUTOMATION_FIELDS = [
    'vehicle.unitNumber',
    'vehicle.licensePlateNumber',
    'trailer.trailerNumber',
    'trailer.trailerNumberTwo',
    'trailer.trailerLicensePlate',
    'trailer.chassisNumber',
    'trailer.containerNumber',
];

export const INVENTORY_PROPERTIES = VEHICLE_PROPERTIES.concat(TRAILER_PROPERTIES);

export const INVENTORY_STATUS = {
    GOOD_TO_GO: 'GOOD_TO_GO',
    TERMINATED: 'TERMINATED',
};

export const INVENTORY_STATUS_LABEL = {
    GOOD_TO_GO: 'Good to Go',
    TERMINATED: 'Terminated',
    IN_SHOP: 'In Shop',
    GROUNDED: 'Grounded',
    IN_LEASE: 'In Lease',
    IN_SALE_TRADE: 'In Sale / Trade',
    ANNUAL_INSPECT: 'Annual Inspect',
    WASH: 'Wash',
    UNAVAILABLE: 'Unavailable',
    BREAKDOWN: 'Breakdown',
};

export const RELATION_TYPE = {
    Tenant: 1,
    ThirdPartyCarrier: 2,
    Vendor: 3,
    Unknown: 4,
};

export const RELATION_TYPE_DROPDOWN_OPTION = {
    [RELATION_TYPE.Tenant]: {
        id: RELATION_TYPE.Tenant,
        label: 'Tenant',
    },
    [RELATION_TYPE.ThirdPartyCarrier]: {
        id: RELATION_TYPE.ThirdPartyCarrier,
        label: 'Third Party Carrier',
    },
    [RELATION_TYPE.Vendor]: {
        id: RELATION_TYPE.Vendor,
        label: 'Vendor',
    },
    [RELATION_TYPE.Unknown]: {
        id: RELATION_TYPE.Unknown,
        label: '',
    },
};

export const CAMERA = {
    STATUS_ACTIVE: 'ACTIVE',
    AUDIO_TYPE: {
        HIKVISION_2WA: 'HIKVISION_2WA',
        EXTENSION_3CX: 'EXTENSION_3CX',
    },
};
export const USER_ROLES = {
    ADMIN: 'admin',
    TEAM_LEADER: 'team_leader',
};

export const PROPERTY_NOT_FOUND = 'aiq.fieldNotExist';

export const AUTOMATION_SOURCE = Object.freeze({
    AUTH_LIST: 'Auth',
    INVENTORY_ITEM: 'Inv',
    EQUIPMENT_ITEM: 'Equip',
    BISON_ANNOUNCEMENT: 'Bison',
    MANUAL_ANNOUNCEMENT: 'Manual',
    APPOINTMENT: 'App',
    HISTORICAL_TRANSACTION: 'Trx',
    AI_OCR: 'alisa', // this must match automation source from BE
    SHEET_ANNOUNCEMENT: 'sheet_announcement',
    CONDITIONALS: 'Conditionals', // conditionals validate-endpoint autofill
    AUTO: 'Auto', // timer-derived Process Time suggestion (FE-only, never from BE)
    CONDOR: 'Condor', // a verified OCR value filled on submit (FE-only, BEAST-13260)
    PROTOCOL: 'Protocol', // step-by-step protocol `/` for form fields the protocol's form leaves out (FE-only, never stored)
});

export const AUTOMATION_SOURCE_TOOLTIP = Object.freeze({
    [AUTOMATION_SOURCE.AUTH_LIST]: 'Authorized List',
    [AUTOMATION_SOURCE.INVENTORY_ITEM]: 'Inventory Item',
    [AUTOMATION_SOURCE.EQUIPMENT_ITEM]: 'Equipment Item',
    [AUTOMATION_SOURCE.BISON_ANNOUNCEMENT]: 'Bison Announcement',
    [AUTOMATION_SOURCE.MANUAL_ANNOUNCEMENT]: 'Manual Announcement',
    [AUTOMATION_SOURCE.APPOINTMENT]: 'Appointment',
    [AUTOMATION_SOURCE.HISTORICAL_TRANSACTION]: 'Historical Transaction',
    [AUTOMATION_SOURCE.AI_OCR]: 'OCR',
    [AUTOMATION_SOURCE.AUTO]: 'Auto (timer-derived)',
    [AUTOMATION_SOURCE.CONDOR]: 'Condor OCR',
    [AUTOMATION_SOURCE.PROTOCOL]: 'Protocol',
});
// PROTOCOL: a transport type change replaces the protocol suggestion; that is not an overwritten automation.
export const OVERWRITTEN_STYLE_NOT_ALLOWED_SOURCES = [AUTOMATION_SOURCE.AUTH_LIST, AUTOMATION_SOURCE.INVENTORY_ITEM, AUTOMATION_SOURCE.PROTOCOL];
// Table name an appointment copy records as the form's active selection (and a dropped copy refers to).
export const APPOINTMENTS_TABLE_NAME = 'appointments';

export const PROCESS_TIME_FIELD = 'processTime';
export const DRIVER_NAME_FIELD = 'person.fullName';
export const PROCESS_TIME_OPTION = Object.freeze({
    SLASH: '/',
    UNDER_30S: '<30 s',
    UNDER_1MIN: '<1 min',
    UNDER_2MIN: '<2 min',
    OVER_2MIN: '>2 min',
});

export const PROCESS_TIME_BUCKETS = Object.freeze([
    { maxSeconds: 30, value: PROCESS_TIME_OPTION.UNDER_30S },
    { maxSeconds: 60, value: PROCESS_TIME_OPTION.UNDER_1MIN },
    { maxSeconds: 120, value: PROCESS_TIME_OPTION.UNDER_2MIN },
    { maxSeconds: Infinity, value: PROCESS_TIME_OPTION.OVER_2MIN },
]);

export const PROCESS_TIME_DEFAULT_SUGGESTION = PROCESS_TIME_OPTION.UNDER_30S;

//

// TODO(BEAST-11698): autofill writes values these two vocabularies produce, not values the location
// configured. `person.identificationType` and `person.idCountry` are both in the 33 fields
// BEAST-11651 made configurable, so a location with its own option list gets an off-list value
// stored - nothing validates on save. It is not a silently skipped field; both paths do produce a
// value:
//   - identificationType: the auth list never carries a configured value at all.
//     ClientPersonnelAuthorization derives it from which of the dl / cdl columns is set, so the
//     payload is only ever 'DL', 'CDL' or null. This map covers both, and matches
//     messages.properties exactly.
//   - idCountry: ClientPersonnel stores the display string ('California (CA)'), and the regex below
//     recovers the constant from it. That agrees with the backend lookup for 52 of the 54 Country
//     constants; COMPANY_ID ('Company ID') and UNKNOWN ('/') have no parentheses, so the regex finds
//     no match and `?? value` stores the display text where every other row stores a constant.
// Resolving both through the field's own lookup, as the save path does with
// resolveLookupValueFromDisplay, would fix all of this - but generateAutofill has no access to the
// field definitions, so formFields has to be threaded through personAutofill (TransactionForm.jsx,
// where it is already in scope and already passed to automationSection). It also changes what
// idCountry stores for those two constants, and '/' is the unknown sentinel other code special-cases.
// Out of scope for BEAST-12750; needs its own ticket and a decision on those two values.
const IDENTIFICATION_TYPE_MAPPING = { DL: "Driver's License", CDL: "Commercial Driver's License", CLP: "Commercial Learner's Permit" };

export const PERSON_AUTOFILL_MAPPING = Object.freeze({
    'person.identificationNumber': { valueField: 'identificationNumber' },
    'person.phoneNumber': { valueField: 'phoneNumber' },
    'person.companyName': { valueField: 'company.name', processOriginalValue: (_, personObj) => personObj?.company?.id }, // Store company.id for matching
    'person.identificationType': {
        valueField: 'identificationType',
        processValue: (value) => IDENTIFICATION_TYPE_MAPPING[value],
        processOriginalValue: (value) => Object.keys(IDENTIFICATION_TYPE_MAPPING).find((k) => IDENTIFICATION_TYPE_MAPPING[k] === value) ?? value,
    }, // Reverse lookup: "Driver's License" → "DL"
    'person.idCountry': { valueField: 'idCountry', processOriginalValue: (value) => value?.match(/\(([^)]+)\)$/)?.[1] ?? value }, // Extract enum from display: "Tennessee (TN)" → "TN"
    'person.companyCardNumber': { valueField: 'companyCardNumber' },
});
export const PERSON_AUTOFILL_MAPPING_CDL_LOOKUP = Object.freeze({
    'person.phoneNumber': { valueField: 'phoneNumber' },
    'person.companyName': { valueField: 'company.name' },
    'person.companyCardNumber': { valueField: 'companyCardNumber' },
});

export const EXTERNAL_ANNOUNCEMENT_SOURCE = Object.freeze({
    BISON: 'BISON',
});

export const TRAILER_NUMBER_FIELDS = ['trailer.trailerNumber', 'trailer.trailerNumberTwo'];

export const EQUIPMENT_MAPPING_LABEL = {
    'trailer.trailerNumber': 'Trailer #',
    'trailer.trailerNumberTwo': 'Trailer #',
    'trailer.containerNumber': 'Container #',
    'trailer.chassisNumber': 'Chassis #',
    'trailer.dollyNumber': 'Dolly #',
    'trailer.equipmentNumber': 'Equipment #',
    'vehicle.unitNumber': 'Unit #',
    'vehicle.licensePlateNumber': 'License Plate #',
};

export const EQUIPMENT_CATEGORY_FILTERS = {
    'vehicle.unitNumber': ['Truck'],
    'vehicle.licensePlateNumber': ['Straight truck', 'Pickup truck', 'Personal', 'Van', 'Bus', 'Utility', 'Emergency'],
    'trailer.trailerNumber': ['Trailer'],
    'trailer.trailerNumberTwo': ['Trailer'],
    'trailer.containerNumber': ['Container'],
    'trailer.chassisNumber': ['Chassis'],
    'trailer.dollyNumber': ['Dolly'],
};

export const INVALID_VALUES = ['', null, undefined];
export const UNKNOWN_SENTINEL_VALUES = ['?', '-1', 'UNKNOWN'];
export const isUnknownSentinel = (value) => value != null && UNKNOWN_SENTINEL_VALUES.includes(value.toString().toUpperCase());

export const EQUIPMENT_MAPPING = {
    FULL_NAME_FIELD: 'person.fullName',
    COMPANY_NAME_FIELD: 'person.companyName',
    LICENSE_PLATE_FIELD: 'vehicle.licensePlateNumber',
    TRANSPORT_TYPE_FIELD: 'vehicle.transportType',
};
